import type { ApiContactPageEntranceBlock } from '@/types';

export function getFacebookUrl(entrance: ApiContactPageEntranceBlock | undefined): string | undefined {
  return entrance?.value.contacts?.find(c => c.icon?.content === '$facebook')?.href;
}
